import { useEffect, useRef } from 'react';
import { pushBackHandler } from '../utils/backStack';

// 모달/팝업 공통 — ESC 키 + 뒤로가기(안드로이드 하드웨어 back/브라우저 back)로 닫기.
// enabled=false 면 비활성(중첩 팝업 제어용).
// onClose 는 ref 로 최신본 참조 — 인라인 콜백이어도 히스토리 등록이 렌더마다 재실행되지 않게 [enabled] 에만 의존.
export function useEscapeClose(onClose: () => void, enabled = true) {
	const closeRef = useRef(onClose);
	closeRef.current = onClose;
	useEffect(() => {
		if (!enabled) return;
		const onKey = (e: KeyboardEvent) => {
			if (e.key === 'Escape') { e.stopPropagation(); closeRef.current(); }
		};
		document.addEventListener('keydown', onKey);
		const unregBack = pushBackHandler(() => closeRef.current());
		return () => {
			document.removeEventListener('keydown', onKey);
			unregBack();
		};
	}, [enabled]);
}
